import block from 'propmods';
import React from 'react';
import { TextInput } from 'lego-on-react';
import { Select } from '../Select/Select';
import { Example, makeEmptyExample, markers } from '../../model/common';
import FieldList from '../Form/FieldList';
import { ucfirst } from '../../utils';

import './ExamplesBuilder.scss';

interface Marker {
    text: string;
    hasRequest: boolean;
}

interface ExamplesBuilderProps {
    required?: boolean;
    disabled?: boolean;
    label: string;
    activationPhrasesOptions: string[];
    values: Example[];
    errors?: string[];
    onChange: (values: Example[]) => void;
    documentationUrl?: string;
    caption?: React.ReactNode;
}

const ExamplesBuilder: React.SFC<ExamplesBuilderProps> = ({
    activationPhrasesOptions,
    ...restProps
}: ExamplesBuilderProps) => (
    <FieldList
        listType="manual"
        defaultValue={makeEmptyExample()}
        minCount={1}
        maxCount={3}
        displayFirstRemoveButton
        disableFirstRemoveButton
        renderInput={({ disabled, onChange, value }, i) => (
            <ExampleBuilder
                label={restProps.label}
                key={i}
                disabled={disabled}
                markers={markers}
                activationPhrasesOptions={activationPhrasesOptions}
                onChange={onChange}
                value={value}
            />
        )}
        {...restProps}
    />
);

export default ExamplesBuilder;

interface ExampleBuilderProps {
    label?: string;
    disabled?: boolean;
    markers: Marker[];
    activationPhrasesOptions: string[];
    value: Example;
    onChange: (value: Example) => void;
}

const b = block('ExampleBuilder');

const ExampleBuilder = (props: ExampleBuilderProps) => (
    <div {...b()}>
        <div {...b('item')}>
            <Select
                label={props.label}
                namespace="command"
                placeholder="Команда"
                type="radiocheck"
                value={props.value.marker}
                onChange={(val) => {
                    props.onChange({
                        ...props.value,
                        marker: val,
                        request: shouldDisplayRequest(val) ? props.value.request : '',
                    });
                }}
                disabled={props.disabled}
                options={props.markers.map((marker) => ({ value: marker.text, text: ucfirst(marker.text) }))}
            />
        </div>
        <div {...b('item')}>
            <Select
                label={props.label}
                namespace="command_name"
                placeholder="Имя"
                type="radiocheck"
                value={props.value.activationPhrase}
                onChange={(val) =>
                    props.onChange({
                        ...props.value,
                        activationPhrase: val,
                    })
                }
                disabled={props.disabled}
                options={props.activationPhrasesOptions.map((phrase) => ({ value: phrase, text: phrase }))}
            />
        </div>
        {shouldDisplayRequest(props.value.marker) && (
            <div {...b('item')}>
                <TextInput
                    placeholder="Запрос"
                    theme="normal"
                    size="s"
                    text={props.value.request}
                    onChange={(val) =>
                        props.onChange({
                            ...props.value,
                            request: val,
                        })
                    }
                    disabled={props.disabled}
                />
            </div>
        )}
    </div>
);

function shouldDisplayRequest(checkedMarker: string) {
    const marker = markers.find((a) => a.text === checkedMarker);

    return marker !== undefined && marker.hasRequest;
}
